import { useAuth0 } from "@auth0/auth0-react";
import { Dropdown, message, Space } from "antd";
import Avatar from "components/Avatar/Avatar";
import DropIcon from "components/Icons/DropIcon";
import {
  HeaderStyle,
  LogoStyle,
  NavBar,
  NavRight,
} from "components/layouts/NewHeader/NewHeader.style";
import WelcomeModal from "components/ui-component/modals/WelcomeModal";
import UserProfile from "components/UserProfile/UserProfile";
import Images from "config/images";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import {
  setErrorPageData,
  setIsErrorPage,
  setLoading,
  setNumber,
  setUserInfo,
  useIsUserInfo,
  setTab,
  clearCommonSlice,
  showInvalidUserModal,
} from "redux/slice/commanSlice";
import { clearSlice, getUserInfo, getUserNumber } from "redux/slice/faxSlice";
import { Modal } from "components/ui-component";
import { useSelector } from "react-redux";
import { backendLogout } from "API/backendLogout";

const UserProfilePopup = () => <UserProfile />;

const NewHeader = () => {
  const WELCOME_STATUS = process.env.REACT_APP_WELCOME_STATUS;
  const [isOpenwelcome, setIsOpenwelcome] = useState<boolean>(false);

  const invalidUserModal = useSelector(
    (state: any) => state.comman.invalidUserModal
  );

  const { user, logout } = useAuth0();
  const dispatch = useAppDispatch();
  const isUserInfo = useIsUserInfo();
  const navigation = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname !== "/") {
      navigation("/");
    }
    dispatch(setTab("inbox"));
  };

  const handleLogout = async () => {
    await backendLogout();
    logout();
    localStorage.clear();
    message.success("Sign out successfully");
    dispatch(clearSlice());
    dispatch(clearCommonSlice());
  };

  function renderInvalidUserMessage(message: string) {
    // Find the first <a ...>...</a> in the message
    const aTagStart = message.indexOf("<a ");
    const aTagEnd = message.indexOf("</a>", aTagStart);

    if (aTagStart === -1 || aTagEnd === -1) return message;

    const before = message.slice(0, aTagStart);

    // Extract the <a ...>...</a> part
    const aTagContent = message.slice(aTagStart, aTagEnd + 4);

    // Extract href and link text
    let url = "";
    let linkText = "";
    const hrefMatch = aTagContent.match(/href=['"]([^'"]+)['"]/i);
    if (hrefMatch) {
      url = hrefMatch[1];
    }
    const linkTextStart = aTagContent.indexOf(">");
    const linkTextEnd = aTagContent.lastIndexOf("<");
    if (
      linkTextStart !== -1 &&
      linkTextEnd !== -1 &&
      linkTextEnd > linkTextStart
    ) {
      linkText = aTagContent.slice(linkTextStart + 1, linkTextEnd);
    }

    const after = message.slice(aTagEnd + 4);

    const baseUrl = url.split("?")[0];

    return (
      <>
        {before}
        <a href={baseUrl} target="_blank" rel="noopener noreferrer">
          {linkText}
        </a>
        {after}
      </>
    );
  }

  const onGetUserNumber = async (number: string) => {
    try {
      dispatch(setNumber(number));
      await dispatch(getUserNumber(number)).unwrap();
    } catch (error: any) {
      console.log("Get USer number Err: --->", error?.message);
    }
  };

  const onGetUserInfo = async () => {
    try {
      localStorage.setItem("userInfoFetched", "true");
      const username = user?.email;
      if (username !== undefined) {
        const res: any = await dispatch(getUserInfo(username)).unwrap();
        if (res?.assigned_number?.length) {
          onGetUserNumber(res.assigned_number?.[0]);
        } else if (res.error === "email account") {
          dispatch(
            showInvalidUserModal({
              error: "Account Not Found",
              message: res?.message || "Invalid User",
            })
          );
          return;
        } else if (res.error === "invalid user") {
          dispatch(setErrorPageData(res));
          dispatch(setIsErrorPage(true));
          navigation("/invalid-user");
          dispatch(setLoading(false));
        }
        const showWelcomeModal = Cookies.get("showWelcomeModal");

        if (WELCOME_STATUS === "enable" && showWelcomeModal !== "false") {
          setIsOpenwelcome(true);
        }
        dispatch(setUserInfo(false));
        dispatch(setLoading(false));
      } else {
        dispatch(setUserInfo(false));
        dispatch(setLoading(false));
      }
    } catch (error: any) {
      dispatch(setIsErrorPage(true));
      navigation("/invalid-user");
      dispatch(setLoading(false));
      console.log("Get USer Info Err: --->", error?.message);
    }
  };

  useEffect(() => {
    if (isUserInfo && localStorage.getItem("userInfoFetched") !== "true") {
      onGetUserInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserInfo]);

  return (
    <HeaderStyle className="header">
      <LogoStyle onClick={handleLogoClick}>
        <img src={Images.BrandLogo} alt="Brand Logo" className="w" />
      </LogoStyle>
      <NavBar>
        <NavRight>
          <Dropdown trigger={["click"]} popupRender={UserProfilePopup}>
            <a href="/" onClick={(e) => e.preventDefault()}>
              <Space>
                <div className="userprofile">
                  <Avatar
                    shape="circle"
                    size="large"
                    username={user?.name}
                    useremail={user?.email}
                    src={user?.picture ?? Images.profile}
                  />
                  <div className="drop-icon">
                    <DropIcon />
                  </div>
                </div>
              </Space>
            </a>
          </Dropdown>
        </NavRight>
      </NavBar>
      <WelcomeModal
        visible={isOpenwelcome}
        onDoneClick={() => {
          setIsOpenwelcome(false);
        }}
        onCancelClick={() => setIsOpenwelcome(false)}
      />
      <Modal
        open={invalidUserModal?.open}
        okText={"Logout"}
        onOk={handleLogout}
        centered={false}
        isCancelButton={false}
        maskClosable={false}
        closable={false}
      >
        <p>
          {invalidUserModal?.message
            ? renderInvalidUserMessage(invalidUserModal?.message)
            : ""}
        </p>
      </Modal>
    </HeaderStyle>
  );
};

export default NewHeader;
